/**
 * Feature flag global de contabilidad (build-time).
 * El acceso a pantallas/menú se controla por modulePermissions (hasAccess), no por rol.
 */
export const isAccountingEnabledByEnv = () =>
  process.env.REACT_APP_SHOW_ACCOUNTING === 'true';

/** Rutas del menú Contabilidad (sidebar / Content). */
export const ACCOUNTING_ROUTE_PATHS = [
  '/balance_8_columnas',
  '/balance_clasificado',
  '/estado_de_resultados_contable',
  '/libro_mayor',
  '/libro_diario',
  '/asientos',
  '/plan_de_cuentas',
  '/centralizacion_contable',
  '/libro-compra-venta',
  '/cierre_apertura_contable',
];

/**
 * moduleIds de Contabilidad (catálogo admin / ROUTE_TO_MODULE).
 * Default-deny para USER_SMARTCFO; habilitar desde server_admin.
 */
export const ACCOUNTING_MODULE_IDS = [
  'balance_8_columnas',
  'balance_clasificado',
  'eerr_contable',
  'libro_mayor',
  'libro_diario',
  'asientos',
  'plan_cuentas',
  'centralizacion_contable',
  'libro_compra_venta',
  'cierre_apertura_contable',
];

/**
 * ¿Está habilitada la feature de contabilidad en este build?
 * Ya no exige rol ADMIN/COLABORADOR/SUPER_COLABORADOR: el acceso real a cada
 * módulo/ruta lo decide modulePermissions (hasAccess) vía useModulePermissions.
 * @param {string[]} [_roles] - ignorado (compat firma histórica)
 * @param {Object} [_company] - ignorado (compat firma histórica)
 * @returns {boolean}
 */
export const showAccounting = (_roles, _company) => isAccountingEnabledByEnv();

/**
 * Env ON + al menos un módulo de Contabilidad concedido (panel admin).
 * Usar en UI de header/config que no va por ruta (sugerencias de cuentas, etc.).
 */
export function hasAnyAccountingModuleAccess(hasModuleAccessFn) {
  if (!isAccountingEnabledByEnv()) return false;
  if (typeof hasModuleAccessFn !== 'function') return false;
  return ACCOUNTING_MODULE_IDS.some((id) => hasModuleAccessFn(id));
}
